export default "__VITE_ASSET__C04JD$CK__"